import { ABI } from './ProxyABI';

// https://github.com/moonbeam-foundation/moonbeam/blob/master/precompiles/proxy/Proxy.sol
export enum ProxyType {
  Any = 'Any',
  NonTransfer = 'NonTransfer',
  Governance = 'Governance',
  Staking = 'Staking',
  CancelProxy = 'CancelProxy',
  Balances = 'Balances',
  AuthorMapping = 'AuthorMapping',
  IdentityJudgement = 'IdentityJudgement',
}

const PROXY_TYPE_VALUES: readonly string[] = Object.values(ProxyType);
export const PROXY_TYPES_LABEL_VALUES: readonly {
  label: string;
  value: string;
}[] = PROXY_TYPE_VALUES.map((type, i) => ({
  label: type,
  value: String(i),
}));

export const PROXY_CONTRACT_ADDRESS =
  '0x000000000000000000000000000000000000080b';

export const ProxyContractABI = ABI;

export const OPEN_GOV_PROXY_TYPES = [
  ProxyType.Any,
  ProxyType.Governance,
  ProxyType.NonTransfer,
] as const;
export const STAKING_PROXY_TYPES = [
  ProxyType.Any,
  ProxyType.NonTransfer,
  ProxyType.Staking,
] as const;
